import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
export default {
	name:'link-work-item',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			linkData: { workItemId: null },
			zendeskInfo: {},
			devOpsTenants: [],
			devOpsTenant:''
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient = null;
			//var count=0;//calls this send data to modal multiple times
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.devOpsTenant = _self.zendeskInfo.userInfo.allowMultiTenant ? _self.zendeskInfo.userInfo.defaultTenant : null;
					if (_self.zendeskInfo.userInfo.allowMultiTenant) {
						_self.getTenantsListFn(_self.devOpsTenant);
					} 
				}
				// count++;
				// if (count == 1) {
				// 	_self.zendeskInfo = data;
				// 	if(_self.$route.params.zdTicketId)_self.zendeskInfo.ticket.id = _self.$route.params.zdTicketId;
				// }
			});
		},
		getTenantsListFn(devOpsTenant){
			let _self = this;
			
			_self.devOpsTenantDataFn(devOpsTenant,function (tenantsResp) {
				_self.devOpsTenants = tenantsResp.data.Data;
				devOpsTenant = devOpsTenant ? devOpsTenant : _self.devOpsTenants[0].organizationName;
				_self.fn().showLoader(false);
			});
		},
		linkWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.linkData;
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;

			if(data.workItemId && data.workItemId.endsWith('/')){
                data.workItemId=data.workItemId.substr(0,data.workItemId.length-1);
            }
            if(data.workItemId.indexOf('https')>=0 && data.workItemId.indexOf('edit')>=0){
                data.workItemId=data.workItemId.split('edit/')[1];
			}
			data.devOpsTenant = _self.devOpsTenant;
			var url=`zendesk/link/${_self.zendeskInfo.ticket.id}/${encodeURIComponent(data.workItemId)}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.data=response.data.Data;
					_self.sendDataToParent(response.data);
				}else if(response.data && response.data.Errors && response.data.Errors.length>0){
					_self.showNotFoundError(response.data.Errors[0].Message);
				}else{
					_self.showNotFoundError(response.data.Data);
				}
				
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.showNotFoundError('Work Item # not found');
				//_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
			modalClient.invoke('destroy');
		},
		showNotFoundError(msg){
			let _self=this;
			_self.userMsg={show:true,type:'danger',list:[msg]};
		},
		devOpsTenantDataFn:function(devOpsTenantId,successCb,errorCb){
            var _self=this;
            var url = `dev-ops/tenants/${devOpsTenantId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		}
	},
	components:{[Select.name]: Select,[Option.name]: Option}
}

